<template>
	<div class="py-3">
		<CRow>
			<CCol>
				<h3 class="typo-h5">
					Buy X Get Y - Usage limit
				</h3>
			</CCol>
		</CRow>
		<CRow>
			<CCol md="10">
				<label>
					Set limits on how many times this promotion and free item(Y) can be used.
				</label>
			</CCol>
			<CCol md="2">
				<div class="d-flex flex-row justify-content-end freebie-apply">
					<CSwitch
						:checked.sync="formData.promotionLimitAll.isApplyLimitAll"
						variant="3d"
						size="sm"
						class="switch-custom"
						color="success"
						@update:checked="handleUpdateIsApplyLimitAll"
					/>
					<span>{{ formData.promotionLimitAll.isApplyLimitAll ? 'On' : 'Off' }}</span>
				</div>
			</CCol>
		</CRow>
		<template v-if="formData.promotionLimitAll.isApplyLimitAll">
			<CRow>
				<CCol
					md="6"
				>
					<BaseInputNumber
						v-model="totalPromotionLimitValue"
						:invalid-feedback="inputErrors($v.formData.promotionLimitAll.totalPromotionLimit)"
						:is-valid="!$v.formData.promotionLimitAll.totalPromotionLimit.$error"
						allow-null-value
						label="Total promotion usage limit"
						append-text="Order"
						text-align="left"
					/>
				</CCol>
				<!-- Limit col -->
				<CCol md="6" class="mt-auto typo-body-1">
					<div>
						<span class="used-reward-order-count">
							{{ (formData.promotionLimitAll.usedRewardOrderCount || 0) | numberFormat }} Order(s)
						</span>
						<span>
							Total promotion used
						</span>
					</div>
					<!-- dummy height when invalid -->
					<div
						v-if="$v.formData.promotionLimitAll.totalPromotionLimit.$error"
						class="dummy-height"
					></div>
				</CCol>
				<CCol
					md="6"
					class="mt-1"
				>
					<label class="label">The maximum number of times this Buy X Get Y promotion can be used across all customers.</label>
				</CCol>
			</CRow>
			<CRow>
				<CCol
					md="6"
				>
					<BaseInputNumber
						v-model="promotionLimitPerOrderValue"
						:invalid-feedback="inputErrors($v.formData.promotionLimitAll.promotionLimitPerOrder)"
						:is-valid="!$v.formData.promotionLimitAll.promotionLimitPerOrder.$error"
						allow-null-value
						label="Usage limit per order"
						append-text="Order"
						text-align="left"
					/>
				</CCol>
				<CCol
					md="6"
				>
					<BaseInputNumber
						v-model="totalFreeItemQtyLimitValue"
						:invalid-feedback="inputErrors($v.formData.promotionLimitAll.totalFreeItemQtyLimit)"
						:is-valid="!$v.formData.promotionLimitAll.totalFreeItemQtyLimit.$error"
						allow-null-value
						label="Total free item (Y) Qty. limit"
						append-text="Qty"
						text-align="left"
					/>
				</CCol>
				<CCol
					md="6"
					class="mt-1"
				>
					<label class="label">Limits how many times this promotion can be applied in a single order.</label>
				</CCol>
				<CCol
					md="6"
					class="mt-1"
				>
					<label class="label">The maximum total quantity of free items (Y) that can be given from this promotion.</label>
				</CCol>
			</CRow>
		</template>
		<template v-else>
			<CRow>
				<CCol>
					<label>
						No limit on how many times this promotion and free item (Y) can be used.
					</label>
				</CCol>
			</CRow>
		</template>
	</div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

import {
	DAPP_REWARD_FREEBIE_CONDITION_EVERY_OPTION,
	DAPP_REWARD_FREEBIE_CONDITION_EVERY,
} from '../enums/promotions';

export default {
	props: {
		formData: {
			type: Object,
			default: () => {},
		},
	},
	validations() {
		if (!this.formData.promotionLimitAll.isApplyLimitAll) {
			return {};
		}
		return {
			formData: {
				promotionLimitAll: {
					totalPromotionLimit: {
						required: requiredIf((value) => value.isApplyLimitAll && value.totalPromotionLimit),
						greaterThanZero: (value) => {
							if (value === undefined || value === null || value === '') {
								return true;
							}
							return value > 0;
						},
					},
					promotionLimitPerOrder: {
						required: requiredIf((value) => value.isApplyLimitAll && value.promotionLimitPerOrder),
						greaterThanZero: (value) => {
							if (value === undefined || value === null || value === '') {
								return true;
							}
							return value > 0;
						},
					},
					totalFreeItemQtyLimit: {
						required: requiredIf((value) => value.isApplyLimitAll && value.totalFreeItemQtyLimit),
						greaterThanZero: (value) => {
							if (value === undefined || value === null || value === '') {
								return true;
							}
							return value > 0;
						},
					},
				},
			},
		};
	},
	data() {
		return {
			DAPP_REWARD_FREEBIE_CONDITION_EVERY_OPTION,
		};
	},
	computed: {
		totalPromotionLimitValue: {
			get() {
				return this.formData.promotionLimitAll.totalPromotionLimit;
			},
			set(value) {
				this.$set(this.formData.promotionLimitAll, 'totalPromotionLimit', value);
			},
		},
		promotionLimitPerOrderValue: {
			get() {
				return this.formData.promotionLimitAll.promotionLimitPerOrder;
			},
			set(value) {
				this.$set(this.formData.promotionLimitAll, 'promotionLimitPerOrder', value);
			},
		},
		totalFreeItemQtyLimitValue: {
			get() {
				return this.formData.promotionLimitAll.totalFreeItemQtyLimit;
			},
			set(value) {
				this.$set(this.formData.promotionLimitAll, 'totalFreeItemQtyLimit', value);
			},
		},
		isPrice() {
			return this.formData.promotionLimitAll.limitType === DAPP_REWARD_FREEBIE_CONDITION_EVERY.PRICE;
		},
	},
	created() {
		if (!this.formData.promotionLimitAll) {
			this.$set(this.formData, 'promotionLimitAll', {});
		}
		if (this.formData.promotionLimitAll.isApplyLimitAll === undefined) {
			this.$set(this.formData.promotionLimitAll, 'isApplyLimitAll', true);
		}
		if (this.formData.promotionLimitAll.totalPromotionLimit === undefined) {
			this.$set(this.formData.promotionLimitAll, 'totalPromotionLimit', null);
		}
		if (this.formData.promotionLimitAll.promotionLimitPerOrder === undefined) {
			this.$set(this.formData.promotionLimitAll, 'promotionLimitPerOrder', null);
		}
		if (this.formData.promotionLimitAll.totalFreeItemQtyLimit === undefined) {
			this.$set(this.formData.promotionLimitAll, 'totalFreeItemQtyLimit', null);
		}
		if (this.formData.promotionLimitAll.usedRewardOrderCount === undefined) {
			this.$set(this.formData.promotionLimitAll, 'usedRewardOrderCount', null);
		}
	},
	methods: {
		handleSelectLimitType() {
			this.formData.promotionLimitAll.freebieLimitValue = null;
		},
		touch() {
			this.$v.$touch();
		},
		inputErrors(validation) {
			if (!validation.required) {
				return this.$t('global.error.required');
			}

			if (!validation.greaterThanZero) {
				return this.$t('global.error.moreThan', { number: '0' });
			}

			return null;
		},
		handleUpdateIsApplyLimitAll(value) {
			if (value) {
				return;
			}
			this.totalPromotionLimitValue = null;
			this.promotionLimitPerOrderValue = null;
			this.totalFreeItemQtyLimitValue = null;
		},
	},
};
</script>

<style lang="scss" scoped>
.freebie-apply {
	gap: 8px;
}

.label {
	@include typo-caption;

	font-weight: $font-weight-bold;
	color: $color-gray-700;
}

.used-reward-order-count {
	color: #e30000;
	font-weight: $font-weight-bold;
}

.dummy-height {
	height: 20px;
}
</style>